<template>
  <div class="content-popup">
    <vs-row class="content-popup pb-5 mb-5">

      <div class="col content-internal mb-5 pt-3" v-html="html">
      </div>
    </vs-row>
  </div>

</template>

<script>

export default {
  name: 'Termos',
  data: () => ({}),
  props: {
    html: String
  },
  created() {

  },
  computed: {
    projectTag() {
      return this.$store.state.project.projectTag;
    },
    company() {
      return this.$store.state.project.entityName;
    },
    projectURL() {
      return this.$store.state.project.projectURL;
    },
    projectTitle() {
      return this.$store.state.project.projectTitle;
    },
    nick() {
      return this.$store.state.project.nickName;
    },
  }
}


</script>

<style scoped>
.content-internal >>> a {
  color: var(--second-color);
}
</style>
